import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StanjeSkladisteService {

  constructor(private _http: HttpClient) { }

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  stanjeSkladista(a: any) {
    return this._http.post(AppConfig.ipAddress + 'stanje_skladista', a)
      .pipe(map((res: any) => res));
  }

  dokumentiZaArtikl(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dokumenti_za_artikl', a)
      .pipe(map((res: any) => res));
  }
  

}
